import { render, staticRenderFns } from "./Disqualifier.vue?vue&type=template&id=0c62eca3"
import script from "./Disqualifier.vue?vue&type=script&lang=js"
export * from "./Disqualifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports